import { render, staticRenderFns } from "./CRUDEmpresas.vue?vue&type=template&id=1954deaa&"
import script from "./CRUDEmpresas.vue?vue&type=script&lang=js&"
export * from "./CRUDEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports